import { render, staticRenderFns } from "./PartnerShop.vue?vue&type=template&id=79650a3c&lang=pug&"
import script from "./PartnerShop.vue?vue&type=script&lang=ts&"
export * from "./PartnerShop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports